<!--  -->
<template>
  <div>
    <div class="form_box">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="企微账户">
          <el-input v-model="form.company_name" />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.phone" class="aaaa" type="number" oninput="if(value.length>11)value=value.slice(0,11)" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addcread">立即创建</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="padding:0 40px">
      <el-table
        :data="tableData"
        style="width:100%; height: 100%;"
        border
        max-height="500"
      >
        <el-table-column
          align="center"
          label="企微账户"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.show">{{ scope.row.account }}</span>
            <el-input
              v-else
              v-model="company_name"
            />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="电话"
        >
          <template slot-scope="scope">
            <span v-if="!scope.row.show">{{ scope.row.phone }}</span>
            <el-input
              v-else
              v-model="phone"
            />
          </template>
        </el-table-column>
        <el-table-column
          :key="mathRandom"
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <span v-show="!scope.row.show">
              <el-button
                type="text"
                size="small"
                @click.native.prevent="modifyAccount(scope.$index, scope.row)"
              >
                修改
              </el-button>
              <el-button
                type="text"
                size="small"
                @click.native.prevent="deleteAccount(scope.row.id)"
              >
                删除
              </el-button>
            </span>
            <span v-show="scope.row.show">
              <el-button
                type="text"
                size="small"
                @click.native.prevent="cancelAccount(scope.$index)"
              >
                取消修改
              </el-button>
              <el-button
                type="text"
                size="small"
                @click.native.prevent="confirmAccount(scope.$index,scope.row)"
              >
                确认修改
              </el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { wechatcomupdata, wechatcompanyaccount, wechatcompanyingaccount, wechatcomupdataaccount, deletetestwechatraccount } from '@/api/providerAccountManagement/servicePorviderList1.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      form: {
        company_name: '',
        phone: ''
      },
      stutes: null,
      pwdFlag: true, // 密码标示 true表示当前是密码形式
      account_name: '',
      login_pwd: '',
      pay_pwd: '',
      mathRandom: null,

      tableData: [],
      query: {
        page: 1,
        page_size: 10
      },
      total: null,

      company_name: '',
      phone: ''
    }
  },
  created() {
    this.accountlist()
  },
  mounted() {

  },
  methods: {
    async accountlist() {
      const data = await wechatcompanyingaccount(this.query)
      console.log('data', data.data.list)
      this.tableData = data.data.list
      this.total = data.data.total
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].show = false
        if (this.tableData[i].clock_in === 1) {
          this.tableData[i].ster = true
        } else {
          this.tableData[i].ster = false
        }
      }
      console.log('this.tableData ', this.tableData)
    },
    async addcread() {
      const reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (this.form.company_name === '') {
        this.$message.error('请填写企微账户')
        return
      }

      if (!reg_tel.test(this.form.phone)) {
        this.$message.error('请填写正确的电话')
        return
      }

      const data = await wechatcompanyaccount({
        account: this.form.company_name,
        phone: this.form.phone
      })
      this.$message({
        message: '添加成功',
        type: 'success'
      })
      this.accountlist()
      this.rest()
      console.log('data', data)
    },

    rest() {
      this.form.company_name = ''
      this.form.phone = ''
    },
    modifyAccount(index, data) {
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].show = false
      }
      this.tableData[index].show = true
      this.company_name = data.account
      this.phone = data.phone
      this.mathRandom = Math.random()
    },
    // 取消修改
    cancelAccount(index) {
      this.tableData[index].show = false
      this.mathRandom = Math.random()
    },
    async confirmAccount(index, item) {
      const id = item.id
      const account = this.company_name
      const phone = this.phone
      const data = await wechatcomupdataaccount(id, account, phone)
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.mathRandom = Math.random()
      this.accountlist()
      this.tableData[index].show = false
      console.log('data', data)
    },
    async deleteAccount(id) {
      const data = await deletetestwechatraccount(id)
      this.$message({
        message: '删除成功',
        type: 'success'
      })
      this.accountlist()
      console.log('data', data)
    },

    async naclick(item) {
      console.log('item', item)
      const id = item.id
      const company_name = item.company_name
      // const clock_in = item.clock_in
      let clockin = null
      if (item.clock_in === 1) {
        clockin = 2
      } else {
        clockin = 1
      }
      const data = await wechatcomupdata(id, company_name, clockin)
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      // this.mathRandom = Math.random()
      this.accountlist()
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.accountlist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.accountlist()
    },
    resback() {
      this.rest()
    }
    // updatawechat() {
    //   this.accountlist()
    // },
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.form_box{
  margin-top: 30px;
  padding: 30px;
}
 ::v-deep .el-switch__core{
    width: 70px !important;
}

::v-deep .aaaa input::-webkit-outer-spin-button,
::v-deep .aaaa input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
::v-deep .aaaa input[type="number"] {
    -moz-appearance: textfield;
}

</style>
